__webpack_require__.p = "/badges-variants-update/referrals-hub/";